import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Merchant } from 'src/app/common/models/merchant';
import { Operator } from 'src/app/common/models/operator';
import { RemainingTraffic } from 'src/app/common/models/remaining-traffic';
import { ArchiveTrafficReport, TrafficReport } from 'src/app/common/models/traffic-report';
import { AuthService } from 'src/app/services/auth-service';
import { TrafficService } from 'src/app/services/traffic.service';


@Component({
  selector: 'app-traffic',
  templateUrl: './traffic.component.html',
  styleUrls: ['./traffic.component.css']
})
export class TrafficComponent {
  trafficData: TrafficReport[] = [];
  groupedData: any[] = [];
  
  archiveTrafficData: TrafficReport[] = [];
  dateRange : Date[] = [];

  remainingTrafficCount: RemainingTraffic = { dcbRemainingCount : 0, dobRemainingCount : 0 };
  
  loading: boolean = false;
  archiveLoading: boolean = false;

  operator: string = '';
  merchant: string = '';
    date = null;

  constructor(private trafficService: TrafficService
    , private authService : AuthService
  ) {
   
   }

   operatorEvent(operator: Operator) { 
    this.operator = operator.id;
  }

  onSelectMerchant(merchant: Merchant | null) {
    this.merchant = merchant?.id ?? '';

    if (this.authService.getMerchantNameFromLocalStorage()) {
      this.loadTraffic();
    }
  
  }

  loadTraffic() {
     
    if (!this.operator || !this.merchant) {
      return;
    }

    this.loading = true;

    this.trafficService.getTraffics(this.operator, this.merchant).subscribe({
      next: traffics => {
        this.trafficData = traffics;

        this.loading = false;

      },
      error: () => {
        this.loading = false;
      }
    })
    
    this.loadRemainingTrafficCount();
  }

  loadRemainingTrafficCount() {
     
    if (!this.operator || !this.merchant) {
      return;
    } 
    this.trafficService.getRemainingTrafficCount(this.operator, this.merchant).subscribe({
      next: traffics => {
        this.remainingTrafficCount = traffics;
  
      },
      error: () => { 
      }
    })
  }

  removeFirstWord(input: string): string { 
    const words = input.split(' '); 
 
    if (words.length === 1) {
      return words[0];  
    } 

    if (words.length == 4) {
      return words.slice(2).join(' ')
    }
    
    return words.slice(1).join(' ');
  }

  onChange(result:Date[]): void {

    console.log('onChange: ', result);
    if (!result || result.length == 0) {
      this.archiveTrafficData = [];
      return;
    }

    this.dateRange = result;
    
  }

  loadArchiveTraffic() {
     
    if (!this.operator || !this.merchant) {
      return;
    }

    this.archiveLoading = true;

    this.trafficService.getArchiveTraffics(this.operator, this.merchant,this.dateRange[0],this.dateRange[1]).subscribe({
      next: traffics => {
        this.archiveTrafficData = traffics;
       
        this.archiveLoading = false;
      },
      error: () => { 
        this.archiveLoading = false;
      }
    }) 
    
  }

}
